import promotion_tiles from "./promotion_tiles"

import Search from "./Search"
import Footer from "./Footer"
import Promotions from "./Promotions"
import ContactUs from "./ContactUs"
import Login from "./Login"
import Signup from "./Signup"
import Activate from "./Activate"
import Businesses from "./Businesses"
import Adverts from "./Adverts"
import Categories from "./Categories"
import Shared from "./Shared"
import Locations from "./Locations"
import Holidays from "./Holidays"
import NewsLetterSubscriptions from "./NewsLetterSubscriptions"

export default {
    name: "ServerClient",
    Home: {
        /*
            var query = {
                old_password: "",
                new_password: "",
                phone_number: ""
            }
        */
        /* eslint-disable no-unused-vars */
        get_promotion_tiles(query, success, fail) {
            var data = promotion_tiles.items;
            success(data);
        }
    },
    Search,
    Footer,
    Promotions,
    ContactUs,
    Login,
    Businesses,
    Adverts,
    Categories,
    Signup,
    Activate,
    Shared,
    Locations,
    Holidays,
    NewsLetterSubscriptions
}